/**
 * Heartbeat ping used to wake the Render-hosted Python AI backend from cold
 * start before a user triggers an AI action.
 *
 * Request plumbing lives in httpClient.ts. This endpoint is fire-and-forget, so
 * a network failure is reported as an `{ error }` sentinel carrying the thrown
 * message rather than propagating.
 */
import { postJson, ErrorResponse } from './httpClient';

export async function wakeBackendIfNeeded(): Promise<unknown | ErrorResponse> {
    return postJson('/api/heartbeat/wake', undefined, {
        networkErrorMessage: (e) => (e as Error)?.message || String(e),
    });
}
